import styled from 'styled-components';

const SearchConditionStyled = styled.div`
  background: #ffffff;
  box-shadow: 0px 0px 4px 0px rgba(181, 181, 181, 0.26);
  border-radius: 10px;
  padding: 32px;
  .search-condition-wrap {
    display: flex;
    flex-direction: row;
    gap: 267px;
    justify-content: space-between;
  }
  .card-content-wrap {
    /* padding: 40px 40px; */
    display: flex;
    flex-direction: row;
    gap: 48px;
    flex: 1;
    div {
      /* width: 100%; */
    }
    .single-select {
      width: 100%;
    }
  }
  .reset {
    margin-right: 14px;
  }
`;

export default SearchConditionStyled;
